export function roundToDecimalPlaces(value: number, decimalPlaces = 2): number {
  if (!Number.isFinite(value)) return value;

  const shiftedValue = Number(`${value}e${decimalPlaces}`);
  return Number(`${Math.round(shiftedValue)}e-${decimalPlaces}`);
}
